import React, { useState, useEffect } from 'react'
import styled from 'styled-components'
import { Link, withRouter } from 'react-router-dom'

import { textTranslation, shouldTranslateTo } from '../utils/utils'

import {
  Title,
  Subtitle,
  CustomSubtitle,
  PrimaryButton,
  PrimaryOutlineButton,
  BrushStoke,
} from './Utils/CustomClasses'

import AwardsCarousel from './AwardsCarousel'
import { logosLink } from './Homepage'
import LogosResponsiveCarousel from './LogosResponsiveCarousel'
import TestimonialsCarouselV2 from './TestimonialsCarouselV2'
import CustomImage from './Utils/CustomImage'

const Container = styled.div`
  background-color: #fff;
  /* margin-top: 40px; */

  /* @media screen and (max-width: 970px) {
        margin-top: 150px;
    }

    @media screen and (max-width: 768px) {
        margin-top:68px;
    }

    @media screen and (max-width: 767px) {
        margin-top: -15px;
    } */
`

const Header = styled.div`
  padding: 110px 5vw 290px 5vw;
  background-image: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url('/images/homepage-v2/header.jpg');
  background-size: cover;
  max-height: calc(100vh - 120px);
  background-position: center;

  text-align: center;

  & > div {
    margin: 0 auto;
  }

  @media screen and (max-width: 980px) {
    padding: 50px 7vw 100px 7vw;
  }
`

const ThinSubtitle = styled(Subtitle)`
  font-weight: 600;
  font-family: 'Source Sans Pro light';
`

const SectionMap = styled.div`
  padding: 44px 9vw 30px 8vw !important;
  background-color: #f6f0e6;

  img {
    width: 100%;
  }

  @media only screen and (max-width: 600px) {
    padding: 34px 5vw 30px 5vw;
  }
`

const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  ${(props) => props.gap && `gap: ${props.gap}`};
  /* flex-wrap: wrap; */

  > div {
    width: 50%;
  }

  @media only screen and (max-width: 980px) {
    flex-wrap: wrap;

    > div {
      width: 100%;
    }
  }

  @media only screen and (max-width: 980px) {
    gap: ${(props) => (props.gapSm ? props.gapSm : '0')};
    ${(props) => props.reverse && 'flex-direction: column-reverse;'}
    flex-wrap: wrap;
    > div {
      width: 100%;
    }
  }

  @media only screen and (max-width: 600px) {
    gap: ${(props) => (props.gapSm ? props.gapSm : '0')};
    ${(props) => props.reverse && 'flex-direction: column-reverse;'}
    flex-wrap: wrap;
    > div {
      width: 100%;
    }
  }
`

const FlexRowPaintSplash = styled.div`
  display: flex;
  flex-direction: row;
  margin: 50px auto 10px;
`

const FlexRowUneven = styled.div`
  display: flex;
  flex-direction: column;
  gap: 80px;
  /* flex-wrap: wrap; */

  /* > :first-child {
        width: 50%;
    }

    > :last-child {
        width: 50%;
    } */

  @media only screen and (max-width: 1024px) {
    flex-wrap: wrap;
    flex-direction: column;
    gap: 50px;
    > div {
      width: 100% !important;
      /* text-align: center; */
    }
  }
`

const Chat = styled.div`
  margin: 0 3vw;
  max-width: 600px;
  background-image: url('/images/homepage-v2/chat-box-2.png');
  background-position: top;
  padding: 32px;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  -webkit-filter: drop-shadow(0px 6px 13px #919eab29);
  filter: drop-shadow(0px 6px 13px #919eab29);

  h2:first-child {
    font-style: italic;
  }

  @media only screen and (max-width: 600px) {
    padding: 29px 26px;
    margin: 0 0;
  }
`

const MapText = styled.div`
  margin: auto 2vw auto 10vw;

  @media only screen and (max-width: 980px) {
    margin: auto 0;

    button {
      margin-bottom: 60px;
    }
  }

  @media only screen and (max-width: 600px) {
    margin: auto 0;

    button {
      margin-bottom: 60px;
    }
  }
`

const DividerSectionDiv = styled.div`
  margin-top: -1px;
  margin-bottom: -1px;
  height: auto;
  /* background-color: red; */

  background-color: ${({ colored }) => (colored ? '#F9F3EA' : '#F6F0E6')};

  img {
    width: 100vw;
    ${(props) => (props.flip ? 'transform: rotate(180deg);' : '')}
  }

  /* 
   background-position: right;
   background-size: 110% 100%;
   
   
   width: 100vw; 
   */
`

const Sections = styled.div`
  padding: 74px 5vw 30px 5vw;
  background-color: ${({ color }) => (color ? color : '#fff')};
  § img {
    width: 100%;
  }

  ${(props) => props.last && 'padding: 74px 5vw 130px 5vw;'}

  @media only screen and (max-width: 980px) {
    padding: 32px 3vw 30px 5vw;
    ${(props) => props.last && 'padding: 24px 3vw 90px 5vw;'}
  }

  @media only screen and (max-width: 600px) {
    padding: 24px 9vw 30px 8vw !important;
    ${(props) => props.last && 'padding: 24px 3vw 90px 5vw;'}
  }
`

const GradientSections = styled(Sections)`
  background: linear-gradient(#ffeadc, #fff5eb);
  padding: 74px 5vw 80px 5vw;
`

const SectionText = styled.div`
  &:first-of-type {
    margin: auto 4.5vw auto 0;

    @media only screen and (max-width: 1024px) {
      margin: auto 4vw auto 0;
    }

    @media only screen and (max-width: 980px) {
      margin: auto 0;
    }

    @media only screen and (max-width: 600px) {
      margin: auto 0;
    }
  }

  &:last-of-type {
    margin: auto 6vw auto 6vw;

    @media only screen and (max-width: 1024px) {
      margin: auto 4vw auto 4vw;
    }

    @media only screen and (max-width: 980px) {
      margin: auto 0;
    }

    @media only screen and (max-width: 600px) {
      margin: auto 0;
    }
  }
`

const SectionTextCircle = styled(SectionText)`
  text-align: center;
  padding: 0 30px;

  @media screen and (max-width: 600px) {
    padding: 0;
  }
`

const SafetySection = styled(Sections)`
  padding: 74px 7vw 30px 8vw !important;
`

const CenterImage = styled.div`
  ${(props) => props.left && 'text-align: left; margin-left: -50px;'}
  img {
    width: 100%;
  }

  @media only screen and (max-width: 980px) {
    ${(props) => props.left && 'margin-left: 0px;'}
  }

  @media only screen and (max-width: 980px) and (min-width: 768px) {
    text-align: center;
    img {
      width: 80%;
    }
  }

  /* margin: auto 0; */
`

const ModImage = styled(CenterImage)`
  margin: auto 10vw auto 0vw;
  img {
    width: calc(100% + 10px);
  }

  @media only screen and (max-width: 980px) and (min-width: 768px) {
    text-align: center;
    img {
      width: 80%;
    }
  }
`

const WhatIsSection = styled.div`
  background-color: #f9f3ea;
  padding: 150px 8vw 60px 8vw;

  @media only screen and (max-width: 1280px) {
    padding: 150px 6vw 80px 6vw;
  }

  @media only screen and (max-width: 980px) {
    padding: 150px 10vw 30px 10vw;
  }

  @media only screen and (max-width: 600px) {
    padding: 72px 7vw 30px 7vw;
  }
`

const WhatIsText = styled.div`
  margin: auto 0;
  text-align: center;
  padding: 0 50px;

  @media only screen and (max-width: 1024px) {
    padding: 0 25px;
  }

  @media screen and (max-width: 980px) {
    margin-bottom: 25px;
  }
`

const WhatIsImage = styled.div`
  margin: auto 0vw;
  text-align: center;
  video,
  img {
    width: 100%;
    max-width: 470px;
    border-radius: 15px;

    @media only screen and (max-width: 1024px) {
      max-width: 380px;
    }
  }
`

const AwardsSection = styled.div`
  background-color: #fffbf4;
  text-align: center !important;
  padding: 74px 8vw 80px 8vw;

  @media only screen and (max-width: 600px) {
    text-align: left;
  }
`

const ModSubtitle = styled(Subtitle)`
  line-height: 176%;
`

const SmallSection = styled.div`
  width: -webkit-fill-available;
  text-align: center;

  padding: 160px 6.5vw 180px 6.5vw;

  &:first-of-type {
    background-color: #154549;
  }

  &:last-of-type {
    background-color: #1e4c50;
  }

  @media only screen and (max-width: 1024px) {
    padding: 80px 6.5vw 80px 6.5vw;
  }

  @media only screen and (max-width: 600px) {
    padding: 80px 7vw 90px 6vw;
  }
`

const Logos = styled.div`
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 5vh 0;
  ${(props) => props.padding && `padding: ${props.padding}`};

  @media screen and (max-width: 1025px) {
    ${(props) => props.paddingMd && `padding: ${props.paddingMd}`};
  }

  @media screen and (max-width: 768px) {
    ${(props) => props.paddingSm && `padding: ${props.paddingSm}`};
  }

  img {
    max-width: 100%;
  }
`

const TestimonialsSection = styled.div`
  background-color: #f6f0e6;
  padding: 74px 9vw 80px 9vw;
`

const VideoSuzanne = styled.div`
  video {
    /* max-width: 390px; */
    width: 100%;
    margin: 0 auto;
  }

  @media only screen and (max-width: 600px) {
    video {
      margin: 0 auto;
    }
  }
`

const TextMembers = styled.div`
  width: 65%;
  margin: 50px auto 0 auto;

  @media only screen and (max-width: 600px) {
    margin: auto 0;

    h1 {
      text-align: left;
      margin-left: 10px;
    }
  }
`

const VideoSection = styled(Sections)`
  padding: 74px 7vw 130px 7vw;
`

const VideoPeter = styled.div`
  video {
    max-width: 580px;
    width: 100%;
    border-radius: 15px;

    @media only screen and (max-width: 980px) {
      margin-bottom: 50px;
    }

    @media only screen and (max-width: 600px) {
      margin-bottom: 50px;
    }
  }
`

const ImageArrow = styled.img`
  display: ${(props) => (props.mobile ? 'none' : 'block')};
  margin: 0 auto;

  @media only screen and (max-width: 1024px) {
    width: 40%;
  }

  @media only screen and (max-width: 980px) {
    width: 50%;
    max-width: 160px;
    display: ${(props) => (!props.mobile ? 'none' : 'block')};
    transform: rotate(50deg);
    margin: 25px auto;
  }

  @media only screen and (max-width: 600px) {
  }
`

const CustomImageWrapper = styled.div`
  & > div {
    margin: 0 auto;
  }
`

const CircleSection = styled.div`
  padding: 80px 8vw 80px 8vw !important;
  background-color: #f6f0e6;

  img {
    width: 100%;
    border-radius: 15px;

    @media only screen and (max-width: 980px) {
      margin-top: 50px;
    }
  }

  @media only screen and (max-width: 600px) {
    padding: 34px 5vw 30px 5vw;
  }
`

const CustomBrush = styled(BrushStoke)`
  background-size: 100% 100%;
  width: fit-content;
  margin: 0 auto;
  margin-bottom: 30px;

  h2 {
    padding: 10px 20px;
    font-style: italic;
  }
`

const CustomTitle = styled(Title)`
  @media only screen and (max-width: 600px) {
    br {
      display: none;
    }
  }
`

const HomepageV2 = () => {
  const [pageText, setPageText] = React.useState([])

  React.useEffect(() => {
    const language = shouldTranslateTo()
    const getPageText = (pageValue, languageValue) => {
      axios
        .get(`/api/page-text/${pageValue}/${languageValue}`)
        .then((response) => {
          let pageText = response.data.map((textItem) => {
            return textItem.text
          })

          setPageText(pageText)
        })
        .catch((err) => {
          console.log('Error getting page text: ', err)
        })
    }

    getPageText('homepage-v2', language)
  }, [])

  const DividerSection = ({ colored, flip }) => {
    return (
      <DividerSectionDiv colored={colored} flip={flip}>
        <img
          src={
            colored
              ? '/images/homepage-v2/divider-colored.svg'
              : '/images/homepage-v2/divider.svg'
          }
        />
      </DividerSectionDiv>
    )
  }

  const DividerSection2 = ({}) => {
    return (
      <DividerSectionDiv>
        <img src={'/images/homepage-v2/divider3.svg'} />
      </DividerSectionDiv>
    )
  }

  const TextChat = () => {
    return (
      <Chat>
        <Subtitle
          color="#154549"
          weight="400"
          size="20px"
          sizemd="1.25rem"
          sizesm="1rem"
          margin="0 0 18px 0"
          dangerouslySetInnerHTML={{
            __html: pageText[48],
          }}
        />
        <Subtitle
          bold
          weight="700"
          color="#154549"
          size="23px"
          sizemd="1.4rem"
          margin="0 0 18px 0"
          dangerouslySetInnerHTML={{ __html: pageText[49] }}
        />
      </Chat>
    )
  }

  if (pageText.length === 0) {
    return (
      <div className="card-body text-center">
        <div
          className="spinner-border homestays-spinner"
          style={{ marginTop: '100px' }}
          role="status"
        >
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    )
  }
  return (
    <Container>
      <Header>
        <Title
          center
          white
          weight="300"
          margin="0 0 70px 0"
          marginsm="120px 0 20px 0"
          size="23px"
          sizemd="1rem"
          sizesm="18px"
          dangerouslySetInnerHTML={{ __html: pageText[0] }}
        />
        <ThinSubtitle
          white
          center
          size="70px"
          sizemd="4rem"
          sizesm="30px"
          margin="0 0 16px 0"
          marginsm="0 0 10px 0"
          dangerouslySetInnerHTML={{ __html: pageText[1] }}
        />
        <Title
          white
          center
          size="70px"
          sizemd="4rem"
          sizesm="35px"
          margin="0 0 40px 0"
          marginsm="0 0 20px 0"
          dangerouslySetInnerHTML={{ __html: pageText[2] }}
        />
        <Link to="/signup">
          <PrimaryButton>
            <a>{pageText[5]}</a>
          </PrimaryButton>
        </Link>
      </Header>
      {/* The Social Travel */}
      <SectionMap>
        <FlexRow reverse>
          <div>
            <TextChat />
            <img src="/images/homepage-v2/map.png" />
          </div>
          <MapText>
            <Title
              color="#154549"
              margin="0 0 40px 0"
              size="40px"
              sizemd="2.5rem"
              sizesm="30px"
              marginsm="0 0 25px 0"
              dangerouslySetInnerHTML={{ __html: pageText[3] }}
            />
            <ModSubtitle
              color="#154549"
              weight="400"
              size="26px"
              sizemd="1.5rem"
              sizesm="1.5rem"
              margin="0 0 50px 0"
              marginmd="0 0 25px 0"
              marginsm="0 0 33px 0"
              dangerouslySetInnerHTML={{ __html: pageText[4] }}
            />
            <Link to="/signup">
              <PrimaryButton>
                <a>{pageText[5]}</a>
              </PrimaryButton>
            </Link>
          </MapText>
        </FlexRow>
        <FlexRowPaintSplash>
          <CustomBrush>
            <Subtitle
              center
              bold
              weight="700"
              color="#154549"
              size="1.5rem"
              marginsm="0 0 0 0"
              dangerouslySetInnerHTML={{
                __html: `${pageText[51]}`,
              }}
            ></Subtitle>
          </CustomBrush>
        </FlexRowPaintSplash>
      </SectionMap>
      {/* Divider */}
      {/*
            <DividerSection2 />
            */}
      {/* Connect with likeminded */}
      {/*
            <GradientSections>
                <CustomTitle
                    center
                    color="#154549"
                    margin="0 0 30px 0"
                    size="2.9vw"
                    sizemd="2.9vw"
                    sizesm="23px"
                    marginsm="0 0 25px 0"
                    dangerouslySetInnerHTML={{ __html: pageText[50] }}
                />
                <CustomBrush>
                    <Subtitle
                        center
                        bold
                        weight="700"
                        color="#154549"
                        size="1.5rem"
                        marginsm="0 0 0 0"
                        dangerouslySetInnerHTML={{
                            __html: `${pageText[51]}`,
                        }}
                    ></Subtitle>
                </CustomBrush>
            </GradientSections>
            */}
      {/* Travel / Homestays */}
      <Sections>
        <FlexRow reverse gapSm="58px">
          <CustomImageWrapper>
            <CustomImage
              imageBig={'/images/homepage-v2/nicola-big.png'}
              imageSmall={'/images/homepage-v2/nicola-small.png'}
              name={pageText[41]}
              text={pageText[42]}
              country={'United Kingdom'}
              countryFlag={'en'}
            />
          </CustomImageWrapper>
          <SectionText>
            <Title
              color="#154549"
              margin="0 0 10px 0"
              size="32px"
              sizemd="2.25rem"
              sizesm="23px"
              dangerouslySetInnerHTML={{ __html: pageText[6] }}
            />
            <ModSubtitle
              color="#154549"
              size="22px"
              sizemd="1.25rem"
              sizesm="18px"
              margin="0 0 50px 0"
              marginsm="0 0 50px 0"
              dangerouslySetInnerHTML={{ __html: pageText[7] }}
            />
            <Title
              color="#154549"
              margin="0 0 10px 0"
              size="32px"
              sizemd="2.25rem"
              sizesm="23px"
              dangerouslySetInnerHTML={{ __html: pageText[8] }}
            />
            <ModSubtitle
              color="#154549"
              size="22px"
              sizemd="1.25rem"
              sizesm="18px"
              margin="0 0 50px 0"
              dangerouslySetInnerHTML={{ __html: pageText[9] }}
            />
            <Link to="/search?seeking=locals">
              <PrimaryOutlineButton>
                <a>{pageText[10]}</a>
              </PrimaryOutlineButton>
            </Link>
          </SectionText>
        </FlexRow>
      </Sections>
      {/* Community / Events */}
      <Sections last>
        <FlexRow gapSm="45px" gap="10px">
          <SectionText>
            <Title
              color="#154549"
              margin="0 0 10px 0"
              size="32px"
              sizemd="2.25rem"
              sizesm="23px"
              dangerouslySetInnerHTML={{ __html: pageText[11] }}
            />
            <ModSubtitle
              color="#154549"
              size="22px"
              sizemd="1.25rem"
              sizesm="18px"
              margin="0 0 50px 0"
              marginsm="0 0 50px 0"
              dangerouslySetInnerHTML={{ __html: pageText[12] }}
            />
            <Title
              color="#154549"
              margin="0 0 10px 0"
              size="32px"
              sizemd="2.25rem"
              sizesm="23px"
              dangerouslySetInnerHTML={{ __html: pageText[13] }}
            />
            <ModSubtitle
              color="#154549"
              size="22px"
              sizemd="1.25rem"
              sizesm="18px"
              margin="0 0 50px 0"
              dangerouslySetInnerHTML={{ __html: pageText[14] }}
            />

            <Link to="/signup">
              <PrimaryOutlineButton>
                <a>{pageText[15]}</a>
              </PrimaryOutlineButton>
            </Link>
          </SectionText>
          <CenterImage left>
            <img src="/images/homepage-v2/community3.png" />
          </CenterImage>
        </FlexRow>
      </Sections>
      {/* What is  */}
      <WhatIsSection>
        <FlexRow>
          <WhatIsText>
            <Subtitle
              weight="600"
              color="#154549"
              size="20px"
              sizemd="1.5rem"
              sizesm="20px"
              margin="0 0 40px 0"
              dangerouslySetInnerHTML={{ __html: pageText[16] }}
            />
            <Title
              color="#154549"
              margin="0 0 20px 0"
              size="50px"
              sizemd="3rem"
              sizesm="23px"
              dangerouslySetInnerHTML={{ __html: pageText[17] }}
            />
            <ImageArrow src="/images/homepage-v2/arrow.svg" />
            <Subtitle
              color="#154549"
              weight="400"
              size="21px"
              sizemd="1.25rem"
              sizesm="20px"
              margin="30px 0 50px 0"
              marginmd="30px 0"
              dangerouslySetInnerHTML={{ __html: pageText[18] }}
            />
            <Link to="/signup">
              <PrimaryButton>
                <a>{pageText[19]}</a>
              </PrimaryButton>
            </Link>

            <ImageArrow mobile src="/images/homepage-v2/arrow.svg" />
          </WhatIsText>
          <WhatIsImage>
            <img src="/images/homepage-v2/phone.png" />
            {/* <video
                            controls="controls"
                            src="/images/homepage-v2/videos/event.mp4"
                        /> */}
          </WhatIsImage>
        </FlexRow>
      </WhatIsSection>
      {/* Divider */}
      <DividerSection colored={true} flip={false} />
      {/* Awards */}
      <AwardsSection>
        <CustomSubtitle
          color="#154549"
          size="21px"
          sizemd="1.25rem"
          sizesm="20px"
          margin="0 0 50px 0"
          dangerouslySetInnerHTML={{ __html: pageText[20] }}
        />
        <AwardsCarousel />
      </AwardsSection>
      {/* Trust & Security / ID */}
      <SafetySection>
        <FlexRow gap="50px">
          <SectionText>
            <Title
              color="#154549"
              margin="0 0 20px 0"
              size="32px"
              sizemd="2.25rem"
              sizesm="23px"
              dangerouslySetInnerHTML={{ __html: pageText[21] }}
            />
            <Subtitle
              color="#154549"
              weight="400"
              size="21px"
              sizemd="1.25rem"
              sizesm="18px"
              margin="0 0 50px 0"
              dangerouslySetInnerHTML={{ __html: pageText[22] }}
            />
            <Title
              color="#154549"
              margin="0 0 20px 0"
              size="32px"
              sizemd="2.25rem"
              sizesm="23px"
              dangerouslySetInnerHTML={{ __html: pageText[23] }}
            />
            <Subtitle
              color="#154549"
              weight="400"
              size="21px"
              sizemd="1.25rem"
              sizesm="18px"
              margin="0 0 50px 0"
              dangerouslySetInnerHTML={{ __html: pageText[24] }}
            />
          </SectionText>
          {/* <ModImage mobileShadow>
                        {window.innerWidth <= 600 ? (
                            <img src="/images/homepage-v2/safety-sm.png" />
                        ) : (
                            <img src="/images/homepage-v2/safety.png" />
                        )}
                    </ModImage> */}
          <CustomImageWrapper>
            <CustomImage
              imageBig={'/images/homepage-v2/marie-big.png'}
              imageSmall={'/images/homepage-v2/marie-small.png'}
              name={pageText[43]}
              text={pageText[44]}
              country={'Ireland'}
              countryFlag={'ie'}
            />
          </CustomImageWrapper>
        </FlexRow>
      </SafetySection>
      {/* Value Build / Pay */}
      <Sections>
        <FlexRow reverse>
          <CenterImage>
            <img src="/images/homepage-v2/real2.png" />
          </CenterImage>
          <SectionText>
            <Title
              color="#154549"
              margin="0 0 20px 0"
              size="32px"
              sizemd="2.25rem"
              sizesm="23px"
              dangerouslySetInnerHTML={{ __html: pageText[25] }}
            />
            <Subtitle
              color="#154549"
              weight="400"
              size="21px"
              sizemd="1.25rem"
              sizesm="18px"
              margin="0 0 50px 0"
              dangerouslySetInnerHTML={{ __html: pageText[26] }}
            />
            <Title
              color="#154549"
              margin="0 0 20px 0"
              size="32px"
              sizemd="2.25rem"
              sizesm="23px"
              dangerouslySetInnerHTML={{ __html: pageText[27] }}
            />
            <Subtitle
              color="#154549"
              weight="400"
              size="21px"
              sizemd="1.25rem"
              sizesm="18px"
              margin="0 0 50px 0"
              dangerouslySetInnerHTML={{ __html: pageText[28] }}
            />
          </SectionText>
        </FlexRow>
      </Sections>
      {/* Divider */}
      <DividerSection colored={false} flip={true} />
      {/* Circle */}
      <CircleSection>
        <FlexRow>
          <SectionTextCircle>
            <Title
              center
              color="#154549"
              margin="0 0 30px 0"
              size="46px"
              sizemd="2.5rem"
              sizesm="23px"
              dangerouslySetInnerHTML={{ __html: pageText[45] }}
            />
            <Subtitle
              center
              color="#154549"
              weight="400"
              size="21px"
              sizemd="1.15rem"
              sizesm="18px"
              margin="0 0 30px 0"
              dangerouslySetInnerHTML={{ __html: pageText[46] }}
            />
          </SectionTextCircle>
          <div>
            <img src="/images/homepage-v2/circle2.png" />
          </div>
        </FlexRow>
      </CircleSection>
      {/* Divider */}
      <DividerSection colored={false} />
      {/* We are changing */}
      <VideoSection color="#ffffff‰" last>
        <FlexRow>
          <VideoPeter>
            <video
              controls="controls"
              poster="/images/homepage-v2/videos/thumb-peter.png"
              src="/images/homepage-v2/videos/peter-video.mp4"
            />
            {/* <img src='/images/homepage-v2/peter.png' /> */}
          </VideoPeter>
          <SectionText>
            <Title
              color="#154549"
              margin="0 0 30px 0"
              size="46px"
              sizemd="2.5rem"
              sizesm="23px"
              dangerouslySetInnerHTML={{ __html: pageText[29] }}
            />
            <Subtitle
              color="#154549"
              weight="400"
              size="21px"
              sizemd="1.15rem"
              sizesm="20px"
              margin="0 0 20px 0"
              dangerouslySetInnerHTML={{ __html: pageText[30] }}
            />
            <Subtitle
              color="#154549"
              weight="400"
              margin="0 0 45px 0"
              size="23px"
              sizemd="1.15rem"
              dangerouslySetInnerHTML={{ __html: pageText[31] }}
            />
          </SectionText>
        </FlexRow>
      </VideoSection>
      {/* Double Section */}
      <FlexRow>
        <SmallSection>
          <Title
            white
            margin="0 0 45px 0"
            size="35px"
            sizemd="2rem"
            sizesm="23px"
            dangerouslySetInnerHTML={{ __html: pageText[33] }}
          />
          <Subtitle
            white
            weight="400"
            size="21px"
            sizemd="1rem"
            sizesm="20px"
            margin="0 0 44px 0"
            dangerouslySetInnerHTML={{ __html: pageText[34] }}
          />
          <Link to="/search?seeking=locals">
            <PrimaryButton>
              <a>{pageText[35]}</a>
            </PrimaryButton>
          </Link>
        </SmallSection>
        <SmallSection>
          <Title
            white
            margin="0 0 45px 0"
            size="35px"
            sizemd="2rem"
            sizesm="23px"
            dangerouslySetInnerHTML={{ __html: pageText[36] }}
          />
          <Subtitle
            white
            weight="400"
            size="21px"
            sizemd="1rem"
            sizesm="20px"
            margin="0 0 44px 0"
            dangerouslySetInnerHTML={{ __html: pageText[37] }}
          />
          <Link to="/search?seeking=homestays">
            <PrimaryButton>
              <a>{pageText[38]}</a>
            </PrimaryButton>
          </Link>
        </SmallSection>
      </FlexRow>
      {/* What Our members have to say */}
      <TestimonialsSection>
        <FlexRowUneven>
          <TextMembers>
            <Title
              color="#154549"
              margin="0 0 40px 0"
              marginmd="0 0 30px 0"
              marginsm="0 0 30px 0"
              size="50px"
              sizemd="2.5rem"
              sizesm="25px"
              dangerouslySetInnerHTML={{ __html: pageText[39] }}
            />
            <TestimonialsCarouselV2 />
          </TextMembers>
          <VideoSuzanne>
            {/* VIDEO */}
            {/* TODO - ADD LOW QUALITY VIDEO */}
            <video
              controls="controls"
              poster="/images/homepage-v2/videos/thumb-suzanne.png"
              src="https://fbc-int.s3.eu-west-1.amazonaws.com/vds/freebird-video.mp4"
            />
          </VideoSuzanne>
        </FlexRowUneven>
      </TestimonialsSection>
      {/* Divider */}
      <DividerSection colored={false} flip={false} />
      {/* Logos */}
      <Logos padding="10vh 7vw 10vh 7vw">
        <Title
          center
          color="#154549"
          size="35px"
          sizemd="2rem"
          sizesm="23px"
          margin="0 0 30px 0"
          smCenter
          dangerouslySetInnerHTML={{
            __html: pageText[40],
          }}
        ></Title>
        <LogosResponsiveCarousel logosLink={logosLink} />
      </Logos>
    </Container>
  )
}
export default HomepageV2
